import { useFormContext } from 'react-hook-form';
import TextField from '../Inputs/TextField';
import styles from './index.module.scss';

const LocationField = () => {
  const {register } = useFormContext();

  return (
    <TextField
      label="Location"
      type="text"
      {...register('location')}
      name="location"
      placeholder={'Location'}
      wrapperClassName={styles.inputWrapper}
      inputClassName={styles.inputField}
    />
  );
};
export default LocationField;
